/**
 * Application configuration constants.
 * Single source of truth for environment-dependent config.
 */

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API_URL = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export const APP_NAME = 'Profitcast';
export const APP_TAGLINE = 'Ad Analytics Platform';
